<template>
	<base-card :title="title" class="mt-28">
		<div class="report_detail_remind" v-for="(item,index) in list" :key="index">
			{{ item }}
		</div>
	</base-card>
</template>
<script>
export default {
    name: 'reportDetailRemind',
    props: {
        list: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="less" scoped>
.report_detail_remind {
	font-size: 26px;
	color: @gray-9;
	margin-bottom: 30px;
	&:last-child {
		margin-bottom: 0;
	}
}
</style>